module.exports = __webpack_public_path__ + "static/media/zylheader.cbc43bb3.png";